var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tabs-component',{attrs:{"tabs-data":_vm.tabsData},on:{"get-selected-tab":_vm.setSelectedTab}}),_c('div',{staticClass:"page-content"},[(_vm.selectedTab === 'users')?_c('users-view'):_vm._e(),(_vm.selectedTab === 'modules')?_c('modules-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }